import React from 'react';
import { Routes, Route, Router } from 'react-router-dom';
import Layout from './components/layout';
import LandingPage from './features/auth/views/landing';
import ConnectPage from './features/dashboard/views/connect';

import Login from './features/auth/views/auth';
import UserProfile from './features/dashboard/views/profile';
import CompanyManagementPage from './features/dashboard/views/company_management/company_management';
import Calendar from './features/calendar/views/calendar';
import SharedTable from './features/shared-table/SharedTable';
import SharedLayout from './components/shared-layout';

import ServicesMap from './features/maps/views/services';
import ShipsMap from './features/maps/views/ships';
import ProjectOnboarding from './features/dashboard/views/project-onboarding';
import ProtectedRoute from './features/auth/views/protected-route';
import ShipmentTable from './features/shipping-table/ShipmentTable';

const App: React.FC = () => {
  return (
    <Routes>
      <Route index path="/" element={<LandingPage />} />
      <Route path="/invite/:token" element={<ConnectPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Layout />}>
        <Route path="/app/onboarding" element={<ProjectOnboarding />} />
        {/* Main app routes - require a project to exist */}
        <Route path="/app/table" element={<ShipmentTable />} />
        <Route path="/app/calendar" element={<Calendar />} />
        <Route
          path="/app/profile"
          element={
            <ProtectedRoute roles={['super_admin']}>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/settings"
          element={
            <ProtectedRoute roles={['super_admin']}>
              <CompanyManagementPage />
            </ProtectedRoute>
          }
        />
        <Route path="/app/maps" element={<ServicesMap />} />
        <Route path="/app/ships" element={<ShipsMap />} />
      </Route>
      <Route path="/" element={<SharedLayout />}>
        <Route path="/shared-view" element={<SharedTable />} />
      </Route>
    </Routes>
  );
};

export default App;
